import { ModelBase } from 'store/model-base';

export class TaxSummary extends ModelBase {
    public name: string;
    public monthly: number;
    public oneTime: number;
    public category: string;
}
